import { defineMessages } from "./define.js";

/** Поиск: the box, the grouped results, and the words around them (SPEC §4.6). */
export const search = defineMessages("search", {
  title: { ru: "Поиск", en: "Search" },
  subtitle: {
    ru: "По всему пространству — прямо на устройстве, без запроса к серверу.",
    en: "Across the whole space — on the device itself, nothing asked of the server.",
  },
  hint: {
    ru: "Ищем по спискам, пунктам, хотелкам, событиям, темам и сообщениям.",
    en: "We look through lists, items, wishes, events, topics and messages.",
  },

  empty: {
    ru: "Ничего не нашлось по запросу «{query}»",
    en: "Nothing found for “{query}”",
  },
  emptyHint: {
    ru: "Ищем только то, что уже загружено на это устройство.",
    en: "Only what is already on this device is searched.",
  },

  // The kinds a hit can be, as the heading over its group.
  kindList: { ru: "Списки", en: "Lists" },
  kindItem: { ru: "Пункты", en: "Items" },
  kindWish: { ru: "Хотелки", en: "Wishes" },
  kindEvent: { ru: "События", en: "Events" },
  kindMessage: { ru: "Сообщения", en: "Messages" },
  kindTopic: { ru: "Темы", en: "Topics" },

  expand: { ru: "Показать ещё {count}", en: "Show {count} more" },
  collapse: { ru: "Свернуть", en: "Show less" },

  // The field itself, reused wherever something is searched.
  fieldPlaceholder: { ru: "Что ищем?", en: "What are you after?" },
  fieldLabel: { ru: "Поиск по пространству", en: "Search the space" },
  fieldClear: { ru: "Очистить", en: "Clear" },

  /** A space whose name this device cannot read still has to be called something. */
  spaceFallback: { ru: "Пространство", en: "Space" },

  roleOwner: { ru: "владелец", en: "owner" },
  roleMember: { ru: "участник", en: "member" },
});
